import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';

// PACKAGES
import { useHistory } from 'react-router-dom';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../components/Button';
import LoadingSpinner from '../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

// TYPES
import { ActivityFeedViewTypes, ViewTypes } from './ActivityFeedModal';
import { DashboardRemoveActivityFeedCommand } from '../../api/models';

const DeleteActivity: React.FC<ActivityFeedViewTypes> = ({
	activity = {},
	showView,
	closeModal,
	refreshActivityFeed
}) => {
	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const history = useHistory();

	const deleteFeedItem = async () => {
		setIsLoading(true);

		const data: DashboardRemoveActivityFeedCommand = { id: activity.id };

		const response = await apibridge.deleteFeedItem(data);

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			if (closeModal) {
				closeModal();
			}

			history.push('/dashboard');

			refreshActivityFeed();
		}
	};

	return (
		<div className="modal-confirmation">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to <strong>remove '{activity.title}'?</strong>
								</h2>

								<section className="actions">
									<Button className="btn-primary full-width" onClick={deleteFeedItem}>
										Yes
									</Button>

									<Button className="btn-secondary full-width" onClick={() => showView(ViewTypes.Read)}>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default DeleteActivity;
